import { AlertTriangle } from "lucide-react"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

interface DeleteDeviceDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  deviceIds: string[]
  onConfirm: () => void
  isLoading?: boolean
}

export function DeleteDeviceDialog({
  open,
  onOpenChange,
  deviceIds,
  onConfirm,
  isLoading = false,
}: DeleteDeviceDialogProps) {
  const isBulk = deviceIds.length > 1
  const displayId = deviceIds[0] || ""

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-card border-border max-w-[400px]">
        <AlertDialogHeader>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-destructive/20 flex items-center justify-center">
              <AlertTriangle className="h-5 w-5 text-destructive" />
            </div>
            <div className="flex-1">
              <AlertDialogTitle className="text-foreground">Delete {isBulk ? "devices" : "device"}?</AlertDialogTitle>
              <AlertDialogDescription className="text-muted-foreground mt-2">
                {isBulk ? (
                  <>
                    This will permanently delete{" "}
                    <span className="font-semibold text-foreground">{deviceIds.length} devices</span>. This action
                    cannot be undone.
                  </>
                ) : (
                  <>
                    This will permanently delete <span className="font-mono text-foreground">{displayId}</span>. This
                    action cannot be undone.
                  </>
                )}
              </AlertDialogDescription>
            </div>
          </div>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-2">
          <AlertDialogCancel
            disabled={isLoading}
            className="bg-secondary border-input text-muted-foreground hover:bg-secondary/80 hover:text-foreground"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault()
              onConfirm()
            }}
            disabled={isLoading}
            className="bg-destructive hover:bg-destructive/90 text-destructive-foreground"
          >
            {isLoading ? "Deleting..." : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
